export const SIGNUP_ATTRIBUTION_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'campaign',
    'campaign_id',
    'source',
    'gclid',
    'fbclid',
    'msclkid',
    'ttclid',
] as const;

export type SignupAttribution = Partial<Record<(typeof SIGNUP_ATTRIBUTION_KEYS)[number], string>>;

export const signupAnalyticsProperties = ({
    method,
    stage,
    referralCode,
    attribution,
}: {
    method: 'email_password' | 'google' | 'apple';
    stage: string;
    referralCode?: string | null;
    attribution?: SignupAttribution;
}): Record<string, string | boolean> => {
    const normalizedReferralCode = referralCode?.trim();
    const campaignProperties = Object.fromEntries(
        Object.entries(attribution ?? {}).map(([key, value]) => [
            key === 'source' ? 'campaign_source' : key,
            value,
        ]),
    );

    return {
        method,
        stage,
        has_referral: Boolean(normalizedReferralCode),
        has_campaign_attribution: Object.keys(campaignProperties).length > 0,
        ...(normalizedReferralCode ? {referral_code: normalizedReferralCode} : {}),
        ...campaignProperties,
    };
};

export const signupAttributionFromSearch = (search: string): SignupAttribution | undefined => {
    const params = new URLSearchParams(search);
    const attribution: SignupAttribution = {};

    SIGNUP_ATTRIBUTION_KEYS.forEach((key) => {
        const value = params.get(key)?.trim();
        if (value) attribution[key] = value.slice(0, 500);
    });

    return Object.keys(attribution).length ? attribution : undefined;
};

export const buildSignupReferralLink = (origin: string, referralCode: string): string => {
    const url = new URL('/open/signup', origin);
    url.searchParams.set('referral', referralCode.trim());
    return url.toString();
};
